<template>
    <v-container fluid class="auditoria-viagens">
        <!-- Mesmo loading flutuante e não bloqueante da Roteirização: uma linha por dia reprocessado -->
        <RoteirizacaoProgressoDestinos
            v-if="painelProgresso.visivel"
            :items="itensProgresso"
            :overall="progressoGeral"
            :running="reprocessando"
            :cancellable="false"
            :title="tituloProgresso"
            :summary-text="resumoProgresso"
            :collapsed.sync="painelProgresso.recolhido"
            @select="abrirDiaReprocessado"
            @close="painelProgresso.visivel = false"
        />
        <!-- Exportadores do sistema, acionados pelo menu Exportar (os botões próprios ficam ocultos) -->
        <div class="d-none">
            <ExportTablePdf ref="exportPdf" :sections-provider="secoesPdf" @export-loading="exportando = $event.loading" />
            <ExportTableCSV ref="exportCsv" :content="csvAtual.content" :headers="csvAtual.headers"
                :title="csvAtual.titulo" :filename="csvAtual.arquivo" />
        </div>
        <!-- Cabeçalho: título, filtros e reprocessamento -->
        <v-card outlined class="mb-4">
            <v-card-title class="pb-1">
                <v-icon left color="primary">mdi-clipboard-check-multiple-outline</v-icon>
                {{ $t('audit.tripAudit.title') }}
            </v-card-title>
            <v-card-subtitle class="pb-2">{{ $t('audit.tripAudit.subtitle') }}</v-card-subtitle>
            <v-card-text>
                <v-form ref="form" v-model="formValidado" @submit.prevent="pesquisa">
                    <v-row dense align="center">
                        <v-col cols="12" sm="6" md="3">
                            <v-menu v-model="menuDti" :close-on-content-click="false" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :value="formataData(dti)" :label="$t('audit.tripAudit.startDay')"
                                        prepend-inner-icon="mdi-calendar" readonly outlined dense hide-details="auto"
                                        :rules="[obrigatorio]" v-bind="attrs" v-on="on" />
                                </template>
                                <v-date-picker v-model="dti" no-title :locale="$i18n.locale" @input="menuDti = false" />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-menu v-model="menuDtf" :close-on-content-click="false" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :value="formataData(dtf)" :label="$t('audit.tripAudit.endDay')"
                                        prepend-inner-icon="mdi-calendar" readonly outlined dense hide-details="auto"
                                        :rules="[obrigatorio, fimDepoisDoInicio]" v-bind="attrs" v-on="on" />
                                </template>
                                <v-date-picker v-model="dtf" no-title :locale="$i18n.locale" @input="menuDtf = false" />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex flex-wrap align-center">
                            <v-btn color="primary" depressed class="mr-3 my-1" type="submit"
                                :loading="loadingPanorama || loadingExecucoes" :disabled="!formValidado">
                                <v-icon left>mdi-magnify</v-icon>
                                {{ $t('audit.tripAudit.search') }}
                            </v-btn>
                            <v-btn v-if="podeReprocessar" color="primary" outlined class="mr-3 my-1" :loading="reprocessando"
                                :disabled="reprocessando" @click="abrirReprocessamento">
                                <v-icon left>mdi-database-refresh</v-icon>
                                {{ $t('audit.tripAudit.reprocess.button') }}
                            </v-btn>
                            <v-menu offset-y left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" outlined class="my-1" :loading="exportando"
                                        :disabled="!panorama" v-bind="attrs" v-on="on">
                                        <v-icon left>mdi-download</v-icon>
                                        {{ $t('audit.tripAudit.export.button') }}
                                        <v-icon right>mdi-menu-down</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item @click="exportaPdf">
                                        <v-list-item-icon class="mr-3"><v-icon color="red darken-2">mdi-file-pdf-box</v-icon></v-list-item-icon>
                                        <v-list-item-title>{{ $t('audit.tripAudit.export.pdf') }}</v-list-item-title>
                                    </v-list-item>
                                    <v-divider class="my-1" />
                                    <v-list-item v-for="op in opcoesCsv" :key="op.chave" @click="exportaCsv(op.chave)">
                                        <v-list-item-icon class="mr-3"><v-icon color="green darken-2">mdi-file-delimited-outline</v-icon></v-list-item-icon>
                                        <v-list-item-title>{{ op.texto }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-card outlined>
            <v-tabs v-model="aba" show-arrows>
                <v-tab><v-icon left small>mdi-chart-box-outline</v-icon>{{ $t('audit.tripAudit.tabs.overview') }}</v-tab>
                <v-tab><v-icon left small>mdi-history</v-icon>{{ $t('audit.tripAudit.tabs.executions') }}</v-tab>
                <v-tab><v-icon left small>mdi-alert-outline</v-icon>{{ $t('audit.tripAudit.tabs.issues') }}</v-tab>
                <v-tab v-if="diaSelecionado">
                    <v-icon left small>mdi-calendar-today</v-icon>
                    {{ $t('audit.tripAudit.tabs.day', { dia: formataData(diaSelecionado.dt_referencia) }) }}
                </v-tab>
            </v-tabs>
            <v-divider />

            <v-tabs-items v-model="aba">
                <!-- Panorama do período -->
                <v-tab-item>
                    <div class="pa-4">
                        <v-progress-linear v-if="loadingPanorama" indeterminate class="mb-4" />
                        <template v-if="panorama">
                            <div class="d-flex flex-wrap align-baseline mb-3">
                                <div class="text-h6 mr-3">{{ $t('audit.tripAudit.overview.title') }}</div>
                                <div class="text-body-2 grey--text text--darken-1">
                                    {{ $t('audit.tripAudit.overview.subtitle', {
                                        dias: panorama.total.dias, auditados: panorama.total.dias_auditados }) }}
                                </div>
                            </div>

                            <v-alert v-if="panorama.total.nao_auditadas" type="warning" text dense class="mb-4">
                                {{ $t('audit.tripAudit.overview.notAudited', { n: numero(panorama.total.nao_auditadas) }) }}
                            </v-alert>
                            <v-alert v-if="!panorama.total.previstas && !panorama.total.realizadas" type="info" text dense>
                                {{ $t('audit.tripAudit.overview.empty') }}
                            </v-alert>

                            <v-row dense>
                                <v-col v-for="card in cardsPanorama" :key="card.chave" cols="6" sm="4" lg="2">
                                    <v-card outlined class="kpi-card fill-height">
                                        <div class="d-flex align-center">
                                            <v-icon :color="card.cor" class="mr-2">{{ card.icone }}</v-icon>
                                            <div class="text-caption grey--text text--darken-1">{{ card.rotulo }}</div>
                                        </div>
                                        <div class="text-h5 font-weight-medium mt-1">{{ card.valor }}</div>
                                        <div v-if="card.dica" class="text-caption grey--text">{{ card.dica }}</div>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <v-card outlined class="mt-4 pa-4">
                                <div class="text-subtitle-1 font-weight-medium mb-2">
                                    {{ $t('audit.tripAudit.overview.distribution') }}
                                </div>
                                <barra-classes :classes="panorama.total.classes" altura="18" />
                                <div class="mt-3">
                                    <v-chip v-for="c in legendaClasses(panorama.total.classes)" :key="c.classe" small
                                        outlined class="mr-2 mb-2">
                                        <v-avatar left :class="corClasse(c.classe)" size="10" />
                                        {{ $t(`audit.tripAudit.classes.${c.classe}`) }}:
                                        <strong class="ml-1">{{ numero(c.total) }}</strong>
                                        <span class="ml-1 grey--text">({{ pct(c.pct) }})</span>
                                    </v-chip>
                                </div>
                            </v-card>

                            <v-row class="mt-2">
                                <v-col cols="12" lg="8">
                                    <merus-data-table :headers="headersPanoramaDias" :items="panorama.dias"
                                        item-key="dt_referencia" sort-by="dt_referencia" :items-per-page="10"
                                        cod-tabela="AUDAUDITORIAVIAGENS__PANORAMA_DIAS" class="tabela-clicavel"
                                        @click:row="abrirDiaPanorama">
                                        <template v-slot:toolbar>
                                            <cadastro-toolbar :title="$t('audit.tripAudit.overview.byDay')" hide-search />
                                        </template>
                                        <template v-slot:[`item.dt_referencia`]="{ item }">{{ formataData(item.dt_referencia) }}</template>
                                        <template v-slot:[`item.cumprimento_pct`]="{ item }">
                                            <indicador-pct :valor="item.cumprimento_pct" />
                                        </template>
                                        <template v-slot:[`item.pontualidade_pct`]="{ item }">
                                            <indicador-pct :valor="item.pontualidade_pct" />
                                        </template>
                                        <template v-slot:[`item.classes`]="{ item }">
                                            <barra-classes :classes="item.classes" altura="10" class="barra-mini" />
                                        </template>
                                        <template v-slot:[`item.inconsistencias`]="{ item }">
                                            <v-chip v-if="item.inconsistencias" x-small color="warning" text-color="white">
                                                {{ item.inconsistencias }}
                                            </v-chip>
                                            <span v-else class="grey--text">0</span>
                                        </template>
                                        <template v-slot:[`item.execucao`]="{ item }">
                                            <span v-if="item.execucao" class="text-caption">
                                                {{ formataDataHora(item.execucao.dt_execucao) }}
                                                <span class="grey--text">· #{{ item.execucao.id_execucao }}</span>
                                            </span>
                                            <v-chip v-else x-small outlined color="grey">
                                                {{ $t('audit.tripAudit.overview.notAuditedDay') }}
                                            </v-chip>
                                        </template>
                                    </merus-data-table>
                                </v-col>
                                <v-col cols="12" lg="4">
                                    <v-card outlined class="fill-height">
                                        <v-card-title class="text-subtitle-1 font-weight-medium">
                                            {{ $t('audit.tripAudit.overview.issuesByType') }}
                                        </v-card-title>
                                        <v-card-text>
                                            <div v-if="!panorama.inconsistencias.length" class="grey--text">
                                                <v-icon small color="success" class="mr-1">mdi-check-circle</v-icon>
                                                {{ $t('audit.tripAudit.overview.noIssues') }}
                                            </div>
                                            <v-list dense class="py-0">
                                                <v-list-item v-for="inc in panorama.inconsistencias" :key="inc.tipo"
                                                    class="px-0" @click="abrirInconsistenciasDoTipo(inc.tipo)">
                                                    <v-list-item-icon class="mr-3">
                                                        <v-icon :color="corSeveridade(inc.severidade)">mdi-alert-circle-outline</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{ tituloInconsistencia(inc.tipo) }}</v-list-item-title>
                                                    </v-list-item-content>
                                                    <v-list-item-action>
                                                        <strong>{{ numero(inc.total) }}</strong>
                                                    </v-list-item-action>
                                                </v-list-item>
                                            </v-list>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <merus-data-table class="mt-2" :headers="headersPanoramaLinhas" :items="panorama.linhas"
                                item-key="id_linha" :items-per-page="10" :search="buscaLinhas"
                                cod-tabela="AUDAUDITORIAVIAGENS__PANORAMA_LINHAS">
                                <template v-slot:toolbar>
                                    <cadastro-toolbar :title="$t('audit.tripAudit.overview.byLine')"
                                        @search="buscaLinhas = $event" />
                                </template>
                                <template v-slot:[`item.cumprimento_pct`]="{ item }">
                                    <indicador-pct :valor="item.cumprimento_pct" />
                                </template>
                                <template v-slot:[`item.pontualidade_pct`]="{ item }">
                                    <indicador-pct :valor="item.pontualidade_pct" />
                                </template>
                                <template v-slot:[`item.classes`]="{ item }">
                                    <barra-classes :classes="item.classes" altura="10" class="barra-mini" />
                                </template>
                            </merus-data-table>
                        </template>
                    </div>
                </v-tab-item>

                <!-- Execuções -> dias -->
                <v-tab-item>
                    <div class="pa-4">
                        <merus-data-table :headers="headersExecucoes" :items="execucoes" item-key="id_execucao"
                            :loading="loadingExecucoes" sort-by="id_execucao" :sort-desc="true"
                            cod-tabela="AUDAUDITORIAVIAGENS__EXECUCOES" :item-class="classeExecucao"
                            class="tabela-clicavel" @click:row="selecionaExecucao">
                            <template v-slot:toolbar>
                                <cadastro-toolbar :title="$t('audit.tripAudit.executionsTitle')" hide-search />
                            </template>
                            <template v-slot:[`item.origem`]="{ item }">
                                <v-chip x-small :color="item.origem === 'MANUAL' ? 'primary' : 'grey'" dark>
                                    {{ $t(`audit.tripAudit.origins.${item.origem}`) }}
                                </v-chip>
                            </template>
                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip x-small :color="corStatus(item.status)" dark>
                                    {{ $t(`audit.tripAudit.statuses.${item.status}`) }}
                                </v-chip>
                            </template>
                            <template v-slot:[`item.periodo`]="{ item }">
                                {{ formataData(item.dt_inicio_periodo) }} – {{ formataData(item.dt_fim_periodo) }}
                            </template>
                            <template v-slot:[`item.dt_inicio`]="{ item }">{{ formataDataHora(item.dt_inicio) }}</template>
                            <template v-slot:[`item.dias`]="{ item }">
                                {{ (item.resumo && item.resumo.dias_ok) || 0 }}/{{ (item.resumo && item.resumo.dias) || 0 }}
                            </template>
                            <template v-slot:[`item.previsto`]="{ item }">
                                <v-chip v-if="item.resumo && item.resumo.opcoes && item.resumo.opcoes.guias_por_viagem"
                                    x-small outlined color="purple">
                                    {{ $t('audit.tripAudit.fields.plannedFromRoster') }}
                                </v-chip>
                                <span v-else class="grey--text text-caption">
                                    {{ $t('audit.tripAudit.fields.plannedOrigins.quadro') }}
                                </span>
                            </template>
                        </merus-data-table>

                        <merus-data-table v-if="execucaoSelecionada" :headers="headersDias" :items="dias"
                            item-key="dt_referencia" :loading="loadingDias" sort-by="dt_referencia"
                            cod-tabela="AUDAUDITORIAVIAGENS__DIAS" class="mt-4 tabela-clicavel"
                            @click:row="selecionaDia">
                            <template v-slot:toolbar>
                                <cadastro-toolbar hide-search
                                    :title="$t('audit.tripAudit.daysOf', { id: execucaoSelecionada.id_execucao })" />
                            </template>
                            <template v-slot:[`item.dt_referencia`]="{ item }">{{ formataData(item.dt_referencia) }}</template>
                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip x-small :color="corStatus(item.status)" dark>
                                    {{ $t(`audit.tripAudit.statuses.${item.status}`) }}
                                </v-chip>
                            </template>
                            <template v-slot:[`item.cumprimento_pct`]="{ item }">
                                <indicador-pct :valor="kpi(item, 'cumprimento_pct')" />
                            </template>
                            <template v-slot:[`item.pontualidade_pct`]="{ item }">
                                <indicador-pct :valor="kpi(item, 'pontualidade_pct')" />
                            </template>
                            <template v-slot:[`item.n_inconsistencias`]="{ item }">{{ totalInconsistencias(item) }}</template>
                        </merus-data-table>
                    </div>
                </v-tab-item>

                <!-- Inconsistências do período -->
                <v-tab-item>
                    <div class="pa-4">
                        <v-row dense align="center" class="mb-2">
                            <v-col cols="12" sm="8" md="6">
                                <v-select v-model="filtroTiposInconsistencia" :items="opcoesTiposInconsistencia" multiple
                                    clearable outlined dense hide-details :menu-props="{ offsetY: true }"
                                    :label="$t('audit.tripAudit.fields.issueType')">
                                    <template v-slot:selection="{ item, index }">
                                        <v-chip v-if="index < 2" small class="my-1">{{ item.text }}</v-chip>
                                        <span v-else-if="index === 2" class="grey--text text-caption">
                                            {{ $t('audit.tripAudit.filters.more', { n: filtroTiposInconsistencia.length - 2 }) }}
                                        </span>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="4" md="2">
                                <v-btn color="primary" depressed :loading="loadingInconsistencias" :disabled="!formValidado"
                                    @click="carregaInconsistencias">
                                    <v-icon left>mdi-magnify</v-icon>{{ $t('audit.tripAudit.search') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                        <merus-data-table :headers="headersInconsistencias" :items="inconsistenciasFormatadas"
                            item-key="id_inconsistencia" :loading="loadingInconsistencias"
                            cod-tabela="AUDAUDITORIAVIAGENS__INCONSISTENCIAS">
                            <template v-slot:toolbar>
                                <cadastro-toolbar :title="$t('audit.tripAudit.issuesTitle')" hide-search />
                            </template>
                            <template v-slot:[`item.severidade`]="{ item }">
                                <v-chip x-small :color="corSeveridade(item.severidade)" dark>
                                    {{ $t(`audit.tripAudit.severities.${item.severidade}`) }}
                                </v-chip>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-btn v-if="item.id_viagem_grid" icon small @click.stop="abrirTrilha(item.id_viagem_grid)">
                                    <v-icon small>mdi-timeline-text-outline</v-icon>
                                </v-btn>
                            </template>
                        </merus-data-table>
                    </div>
                </v-tab-item>

                <!-- Dia selecionado -->
                <v-tab-item v-if="diaSelecionado">
                    <div class="pa-4">
                        <div class="d-flex flex-wrap align-baseline mb-3">
                            <div class="text-h6 mr-3">
                                {{ $t('audit.tripAudit.day.title', { dia: formataData(diaSelecionado.dt_referencia) }) }}
                            </div>
                            <div class="text-body-2 grey--text text--darken-1">
                                {{ $t('audit.tripAudit.day.execution', { id: diaSelecionado.id_execucao }) }}
                            </div>
                        </div>

                        <v-row dense>
                            <v-col v-for="card in cardsDia" :key="card.chave" cols="6" sm="4" md="3" lg="2">
                                <v-card outlined class="kpi-card fill-height">
                                    <div class="d-flex align-center">
                                        <v-icon :color="card.cor" small class="mr-2">{{ card.icone }}</v-icon>
                                        <div class="text-caption grey--text text--darken-1">{{ card.rotulo }}</div>
                                    </div>
                                    <div class="text-h6 font-weight-medium mt-1">{{ card.valor }}</div>
                                </v-card>
                            </v-col>
                        </v-row>

                        <v-card outlined class="mt-4 pa-4">
                            <div class="d-flex flex-wrap align-baseline mb-2">
                                <div class="text-subtitle-1 font-weight-medium mr-3">
                                    {{ $t('audit.tripAudit.overview.distribution') }}
                                </div>
                                <div class="text-caption grey--text">{{ $t('audit.tripAudit.overview.distributionHint') }}</div>
                            </div>
                            <barra-classes :classes="classesDia" altura="18" />
                            <div class="mt-3">
                                <v-chip v-for="c in legendaClasses(classesDia)" :key="c.classe" small class="mr-2 mb-2"
                                    :outlined="!filtroClasses.includes(c.classe)"
                                    :color="filtroClasses.includes(c.classe) ? corClasse(c.classe) : undefined"
                                    :dark="filtroClasses.includes(c.classe)" @click="alternaClasse(c.classe)">
                                    <v-avatar left :class="corClasse(c.classe)" size="10" />
                                    {{ $t(`audit.tripAudit.classes.${c.classe}`) }}:
                                    <strong class="ml-1">{{ numero(c.total) }}</strong>
                                    <span class="ml-1">({{ pct(c.pct) }})</span>
                                </v-chip>
                            </div>
                        </v-card>

                        <v-tabs v-model="abaDia" class="mt-4">
                            <v-tab>{{ $t('audit.tripAudit.tabs.trips') }} ({{ viagensFiltradas.length }})</v-tab>
                            <v-tab>{{ $t('audit.tripAudit.tabs.removed') }} ({{ removidas.length }})</v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="abaDia">
                            <v-tab-item>
                                <v-row dense align="center" class="mt-3 mb-1">
                                    <v-col cols="12" sm="6" md="4">
                                        <v-select v-model="filtroClasses" :items="opcoesClasses" multiple clearable outlined
                                            dense hide-details :menu-props="{ offsetY: true }"
                                            :label="$t('audit.tripAudit.fields.classification')"
                                            :placeholder="$t('audit.tripAudit.filters.allClasses')">
                                            <template v-slot:item="{ item, attrs, on }">
                                                <v-list-item v-bind="attrs" v-on="on">
                                                    <v-icon class="mr-3" :color="attrs.inputValue ? 'primary' : undefined">
                                                        {{ attrs.inputValue ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                                                    </v-icon>
                                                    <v-avatar :class="corClasse(item.value)" size="10" class="mr-2" />
                                                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                                                </v-list-item>
                                            </template>
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip v-if="index < 2" small dark class="my-1" :color="corClasse(item.value)">
                                                    {{ item.text }}
                                                </v-chip>
                                                <span v-else-if="index === 2" class="grey--text text-caption">
                                                    {{ $t('audit.tripAudit.filters.more', { n: filtroClasses.length - 2 }) }}
                                                </span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-switch v-model="somenteProblemas" inset hide-details class="mt-0"
                                            :label="$t('audit.tripAudit.onlyProblems')" />
                                    </v-col>
                                </v-row>
                                <merus-data-table :headers="headersViagens" :items="viagensFiltradas"
                                    item-key="id_viagem_grid" :loading="loadingViagens" :search="buscaViagens"
                                    cod-tabela="AUDAUDITORIAVIAGENS__VIAGENS">
                                    <template v-slot:toolbar>
                                        <cadastro-toolbar :title="$t('audit.tripAudit.day.tripsTitle')"
                                            @search="buscaViagens = $event" />
                                    </template>
                                    <template v-slot:[`item.classificacao_auditoria`]="{ item }">
                                        <v-chip v-if="item.classificacao_auditoria" x-small dark
                                            :color="corClasse(item.classificacao_auditoria)">
                                            {{ $t(`audit.tripAudit.classes.${item.classificacao_auditoria}`) }}
                                        </v-chip>
                                        <v-tooltip v-else bottom max-width="360">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-chip x-small outlined color="grey darken-1" v-bind="attrs" v-on="on">
                                                    <v-icon x-small left>mdi-help-circle-outline</v-icon>
                                                    {{ $t(`audit.tripAudit.notClassified.${motivoSemClassificacao(item)}`) }}
                                                </v-chip>
                                            </template>
                                            <span>{{ $t(`audit.tripAudit.notClassified.${motivoSemClassificacao(item)}Hint`) }}</span>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.horario_saida_prevista`]="{ item }">
                                        {{ formataHora(item.horario_saida_prevista) }}
                                        <v-chip v-if="item.origem_previsto === 'GUIA'" x-small outlined color="purple" class="ml-1"
                                            :title="$t('audit.tripAudit.fields.plannedFromRoster')">
                                            {{ $t('audit.tripAudit.fields.plannedOrigins.guia') }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:[`item.horario_saida_realizada`]="{ item }">{{ formataHora(item.horario_saida_realizada) }}</template>
                                    <template v-slot:[`item.horario_chegada_realizada`]="{ item }">{{ formataHora(item.horario_chegada_realizada) }}</template>
                                    <template v-slot:[`item.abertura`]="{ item }">{{ motivo('opening', item.tipo_abertura_auditoria) }}</template>
                                    <template v-slot:[`item.fechamento`]="{ item }">{{ motivo('closing', item.tipo_fechamento_auditoria) }}</template>
                                    <template v-slot:[`item.n_inconsistencias`]="{ item }">
                                        <v-chip v-if="item.n_inconsistencias" x-small color="warning" dark>{{ item.n_inconsistencias }}</v-chip>
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                        <v-tooltip left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon small v-bind="attrs" v-on="on" @click.stop="abrirTrilha(item.id_viagem_grid)">
                                                    <v-icon small>mdi-timeline-text-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>{{ $t('audit.tripAudit.seeTrail') }}</span>
                                        </v-tooltip>
                                    </template>
                                </merus-data-table>
                            </v-tab-item>
                            <v-tab-item>
                                <merus-data-table class="mt-3" :headers="headersRemovidas" :items="removidasFormatadas"
                                    item-key="id_evento" :loading="loadingViagens" cod-tabela="AUDAUDITORIAVIAGENS__REMOVIDAS">
                                    <template v-slot:toolbar>
                                        <cadastro-toolbar :title="$t('audit.tripAudit.day.removedTitle')" hide-search />
                                    </template>
                                    <template v-slot:[`item.actions`]="{ item }">
                                        <v-btn v-if="item.id_viagem_grid" icon small @click.stop="abrirTrilha(item.id_viagem_grid)">
                                            <v-icon small>mdi-timeline-text-outline</v-icon>
                                        </v-btn>
                                    </template>
                                </merus-data-table>
                            </v-tab-item>
                        </v-tabs-items>
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </v-card>

        <!-- Linha do tempo da viagem -->
        <v-navigation-drawer v-model="drawerTrilha" right fixed temporary width="640">
            <v-toolbar color="primary" dark flat>
                <v-toolbar-title>
                    {{ $t('audit.tripAudit.trail.title', { id: trilhaViagemId }) }}
                </v-toolbar-title>
                <v-spacer />
                <v-btn icon @click="drawerTrilha = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-progress-linear v-if="loadingTrilha" indeterminate />
            <div class="pa-4" v-if="!loadingTrilha">
                <v-card v-if="trilha.viagem" outlined class="mb-4 pa-3">
                    <div class="d-flex align-center justify-space-between">
                        <div class="text-subtitle-1 font-weight-medium">
                            {{ trilha.viagem.cod_linha }} · {{ trilha.viagem.descricao_sentido }}
                        </div>
                        <v-chip v-if="trilha.viagem.classificacao_auditoria" small dark
                            :color="corClasse(trilha.viagem.classificacao_auditoria)">
                            {{ $t(`audit.tripAudit.classes.${trilha.viagem.classificacao_auditoria}`) }}
                        </v-chip>
                    </div>
                    <v-row dense class="mt-2 text-body-2">
                        <v-col cols="6" sm="3">
                            <div class="text-caption grey--text">{{ $t('audit.tripAudit.fields.vehicle') }}</div>
                            {{ trilha.viagem.numero_ordem_veiculo || '-' }}
                        </v-col>
                        <v-col cols="6" sm="3">
                            <div class="text-caption grey--text">
                                {{ $t('audit.tripAudit.fields.planned') }}
                                <v-chip v-if="trilha.viagem.origem_previsto === 'GUIA'" x-small outlined color="purple" class="ml-1">
                                    {{ $t('audit.tripAudit.fields.plannedOrigins.guia') }}
                                </v-chip>
                            </div>
                            {{ formataDataHora(trilha.viagem.horario_saida_prevista) || '-' }}
                        </v-col>
                        <v-col cols="6" sm="3">
                            <div class="text-caption grey--text">{{ $t('audit.tripAudit.fields.departure') }}</div>
                            {{ formataDataHora(trilha.viagem.horario_saida_realizada) || '-' }}
                        </v-col>
                        <v-col cols="6" sm="3">
                            <div class="text-caption grey--text">{{ $t('audit.tripAudit.fields.arrival') }}</div>
                            {{ formataDataHora(trilha.viagem.horario_chegada_realizada) || '-' }}
                        </v-col>
                    </v-row>
                </v-card>
                <v-alert v-else type="warning" dense text>{{ $t('audit.tripAudit.trail.tripNotInGrid') }}</v-alert>

                <v-alert v-for="inc in trilha.inconsistencias" :key="inc.id_inconsistencia" dense text
                    :type="inc.severidade === 'ERRO' ? 'error' : 'warning'" class="mb-2">
                    <strong>{{ tituloInconsistencia(inc.tipo) }}</strong> — {{ descricaoInconsistencia(inc) }}
                </v-alert>

                <v-select v-if="execucoesTrilha.length > 1" v-model="execucaoTrilha" :items="execucoesTrilha"
                    :label="$t('audit.tripAudit.trail.execution')" outlined dense hide-details class="mb-3"
                    :menu-props="{ offsetY: true }" />

                <div v-if="!eventosTrilha.length" class="text-caption grey--text">{{ $t('audit.tripAudit.trail.empty') }}</div>
                <v-timeline dense align-top>
                    <v-timeline-item v-for="ev in eventosTrilha" :key="ev.id_evento" small
                        :color="corSeveridade(ev.severidade)" :icon="iconeEtapa(ev.etapa)" fill-dot>
                        <div class="text-caption grey--text">{{ $t(`audit.tripAudit.stages.${ev.etapa}`) }}</div>
                        <div class="text-body-2">{{ mensagemEvento(ev) }}</div>
                        <a v-if="temDetalhes(ev)" class="text-caption" @click="alternaDetalhes(ev.id_evento)">
                            {{ detalhesAbertos[ev.id_evento] ? $t('audit.tripAudit.trail.hideDetails') : $t('audit.tripAudit.trail.showDetails') }}
                        </a>
                        <div v-if="detalhesAbertos[ev.id_evento]" class="trilha-detalhes">
                            <template v-for="(linha, i) in linhasParametros(ev.params)">
                                <div v-if="linha.tabela" :key="`t${i}`" class="mt-2">
                                    <div class="text-caption font-weight-medium">{{ linha.rotulo }}</div>
                                    <v-simple-table dense class="tabela-detalhe">
                                        <thead>
                                            <tr><th v-for="c in linha.tabela.colunas" :key="c.chave">{{ c.rotulo }}</th></tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(l, j) in linha.tabela.linhas" :key="j">
                                                <td v-for="c in linha.tabela.colunas" :key="c.chave">{{ l[c.chave] }}</td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </div>
                                <div v-else :key="`p${i}`" class="detalhe-linha">
                                    <span class="detalhe-rotulo">{{ linha.rotulo }}</span>
                                    <span>{{ linha.valor }}</span>
                                </div>
                            </template>
                            <template v-for="(cmp, i) in comparacoes(ev)">
                                <div :key="`c${i}`" class="mt-2">
                                    <div v-if="cmp.titulo" class="text-caption font-weight-medium">{{ cmp.titulo }}</div>
                                    <v-simple-table dense class="tabela-detalhe">
                                        <thead>
                                            <tr>
                                                <th>{{ $t('audit.tripAudit.details.field') }}</th>
                                                <th v-if="cmp.temAntes">{{ $t('audit.tripAudit.details.before') }}</th>
                                                <th v-if="cmp.temDepois">{{ $t('audit.tripAudit.details.after') }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="l in cmp.linhas" :key="l.chave" :class="{ 'linha-alterada': l.mudou }">
                                                <td class="detalhe-rotulo">{{ l.rotulo }}</td>
                                                <td v-if="cmp.temAntes">{{ l.antes }}</td>
                                                <td v-if="cmp.temDepois">{{ l.depois }}</td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>
                                </div>
                            </template>
                        </div>
                    </v-timeline-item>
                </v-timeline>
            </div>
        </v-navigation-drawer>

        <!-- Confirmação do reprocessamento -->
        <v-dialog v-model="dialogReprocessamento" max-width="560">
            <v-card>
                <v-card-title>{{ $t('audit.tripAudit.reprocess.title') }}</v-card-title>
                <v-card-text>
                    <p>{{ $t('audit.tripAudit.reprocess.description') }}</p>
                    <v-row dense>
                        <v-col cols="12" sm="6">
                            <v-menu v-model="menuReprocDti" :close-on-content-click="false" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :value="formataData(reprocDti)" :label="$t('audit.tripAudit.startDay')"
                                        prepend-inner-icon="mdi-calendar" readonly outlined dense hide-details
                                        v-bind="attrs" v-on="on" />
                                </template>
                                <v-date-picker v-model="reprocDti" no-title :locale="$i18n.locale" :max="hoje"
                                    @input="menuReprocDti = false" />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-menu v-model="menuReprocDtf" :close-on-content-click="false" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :value="formataData(reprocDtf)" :label="$t('audit.tripAudit.endDay')"
                                        prepend-inner-icon="mdi-calendar" readonly outlined dense hide-details
                                        v-bind="attrs" v-on="on" />
                                </template>
                                <v-date-picker v-model="reprocDtf" no-title :locale="$i18n.locale" :max="hoje"
                                    @input="menuReprocDtf = false" />
                            </v-menu>
                        </v-col>
                    </v-row>
                    <div class="text-subtitle-2 mt-4">{{ $t('audit.tripAudit.reprocess.plannedSource.label') }}</div>
                    <v-radio-group v-model="reprocGuias" hide-details class="mt-1">
                        <v-radio value="config" :label="$t('audit.tripAudit.reprocess.plannedSource.config', {
                            valor: $t(`audit.tripAudit.reprocess.plannedSource.${guiasPorViagemPadrao ? 'yes' : 'no'}`) })" />
                        <v-radio value="on" :label="$t('audit.tripAudit.reprocess.plannedSource.on')" />
                        <v-radio value="off" :label="$t('audit.tripAudit.reprocess.plannedSource.off')" />
                    </v-radio-group>
                    <div class="text-caption grey--text mt-1">{{ $t('audit.tripAudit.reprocess.plannedSource.hint') }}</div>
                    <v-alert v-if="erroPeriodoReprocessamento" type="warning" dense text class="mt-4 mb-0">
                        {{ erroPeriodoReprocessamento }}
                    </v-alert>
                    <v-alert v-else type="info" dense text class="mt-4 mb-0">
                        {{ $t('audit.tripAudit.reprocess.summary', { dias: diasReprocessamento }) }}
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogReprocessamento = false">{{ $t('button.cancel') }}</v-btn>
                    <v-btn color="primary" depressed :disabled="!!erroPeriodoReprocessamento" @click="confirmarReprocessamento">
                        {{ $t('audit.tripAudit.reprocess.confirm') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import EventBus from '@/utils/eventBus';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import { VProgressLinear } from 'vuetify/lib';
import ExportTableCSV from './ExportTableCSV.vue';
import ExportTablePdf from './ExportTablePdf.vue';
import RoteirizacaoProgressoDestinos from './Roteirizacao/RoteirizacaoProgressoDestinos.vue';

/** Espelhados em api/routers/audit/reprocessaauditoriaviagens.js e no worker do scheduler. */
const MAX_DIAS_REPROCESSAMENTO = 31;
const ROTA_REPROCESSAMENTO = '/api/v1.0/audit/reprocessaauditoriaviagens';
const POLL_MS = 5000;
/** Um mês com pós-processamento pode levar horas; o polling desiste depois disso. */
const TIMEOUT_MS = 6 * 60 * 60 * 1000;
const PENDING_TIMEOUT_MS = 3 * 60 * 1000;
const DIA_MS = 86400000;
const DATA_HORA_RE = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/;
const DATA_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Ordem de exibição: o que está ok primeiro, o que precisa de atenção depois. */
const CLASSES = ['CONFORME', 'ADIANTADA', 'ATRASADA', 'EXTRA', 'INCOMPLETA', 'SUGERIDA', 'DIVERGENTE_MANUAL',
    'DUPLICATA_MANUAL', 'INVALIDA', 'NAO_REALIZADA'];
const TIPOS_INCONSISTENCIA = ['LINHA_INEXISTENTE', 'SOBREPOSICAO_VEICULO', 'FIM_ANTES_DO_INICIO', 'DURACAO_EXCESSIVA', 'DUPLICATA_MANUAL',
    'DIVERGENCIA_GUIA_POSICAO', 'EMBARQUES_SEM_LINHA', 'EMBARQUES_SEM_VIAGEM', 'VIAGEM_SEM_LINHA',
    'VIAGEM_EM_DOIS_SLOTS_MANUAIS', 'GUIA_DUPLICADA'];
const ICONES_ETAPA = {
    PREVISTO: 'mdi-calendar-account', FONTES: 'mdi-source-branch', CANDIDATOS: 'mdi-map-marker-path', CONSOLIDACAO: 'mdi-call-merge',
    INVARIANTES: 'mdi-alert-decagram', SUGESTOES: 'mdi-lightbulb-on-outline', VALIDADE: 'mdi-check-decagram',
    ASSOCIACAO: 'mdi-calendar-clock', RECONCILIACAO: 'mdi-database-sync', EMBARQUES: 'mdi-account-group',
    INSIGHTS: 'mdi-chart-box-outline',
};
const CORES_CLASSE = {
    CONFORME: 'success', ADIANTADA: 'teal', ATRASADA: 'orange darken-2', EXTRA: 'blue-grey', INCOMPLETA: 'amber darken-2',
    SUGERIDA: 'purple', DIVERGENTE_MANUAL: 'indigo', DUPLICATA_MANUAL: 'brown', INVALIDA: 'red darken-2', NAO_REALIZADA: 'grey',
};

/** Avanço dentro de um dia conforme a etapa informada pelo worker (executor.audita_periodo). */
const PCT_ETAPA = { AUDITORIA: 10, CORRELACAO: 45, KM: 60, EMBARQUES: 75, PARAMETROS_GRID: 90, FIM: 100 };
const VISUAL_STATUS = {
    queued: { icon: 'mdi-clock-outline', color: 'grey' },
    running: { icon: 'mdi-progress-clock', color: 'primary' },
    ready: { icon: 'mdi-check-circle', color: 'success' },
    error: { icon: 'mdi-alert-circle', color: 'error' },
};
/** Cores (hex) do gráfico do PDF. */
const COR_CUMPRIMENTO = '#1976d2';
const COR_PONTUALIDADE = '#43a047';

function somaDias(iso, n) {
    const ms = msDia(iso);
    if (!Number.isFinite(ms)) return null;
    return new Date(ms + n * DIA_MS).toISOString().slice(0, 10);
}

// --- Detalhes da trilha: como cada parâmetro gravado pelo monitor aparece para o usuário -----
/** Identificadores internos que não dizem nada ao usuário. */
const PARAMETROS_OCULTOS = new Set(['chave', 'id_veiculo', 'id_linha', 'id_sentido', 'id_guia', 'ids']);
/** Parâmetros em minutos. */
const PARAMETROS_MINUTOS = new Set(['desvio_min', 'duracao_min', 'limite_min', 'tempo_minimo_min', 'tempo_medio_min',
    'sobreposicao_min', 'desvio_max_min']);
/** Campos da "fotografia" de uma viagem (Viagem.resumo() no monitor) mostrados no antes/depois. */
const CAMPOS_VIAGEM = ['id_viagem_grid', 'cod_linha', 'dt_inicio', 'dt_fim', 'fontes', 'fonte_linha'];

function isoDia(d) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function msDia(valor) {
    const m = DATA_RE.exec(String(valor || ''));
    return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) : NaN;
}

function ehViagem(obj) {
    return obj && typeof obj === 'object' && !Array.isArray(obj) && ('dt_inicio' in obj || 'fontes' in obj);
}

/** Barra horizontal com a proporção de cada classificação. */
const BarraClasses = {
    props: { classes: { type: Object, default: () => ({}) }, altura: { type: [String, Number], default: 12 } },
    render(h) {
        const total = CLASSES.reduce((a, c) => a + (this.classes[c] || 0), 0);
        const segmentos = CLASSES.filter((c) => this.classes[c]).map((c) => h('div', {
            class: CORES_CLASSE[c],
            style: { flex: this.classes[c] },
            attrs: { title: `${this.$t(`audit.tripAudit.classes.${c}`)}: ${this.classes[c]}` },
        }));
        return h('div', {
            class: 'barra-classes',
            style: { height: `${this.altura}px` },
        }, total ? segmentos : [h('div', { class: 'grey lighten-3', style: { flex: 1 } })]);
    },
};

/** Percentual com uma barrinha colorida pelo nível. */
const IndicadorPct = {
    props: { valor: { type: Number, default: null } },
    render(h) {
        if (this.valor == null) return h('span', { class: 'grey--text' }, '-');
        const cor = this.valor >= 90 ? 'success' : this.valor >= 70 ? 'warning' : 'error';
        return h('div', { class: 'indicador-pct' }, [
            h('span', `${String(this.valor).replace('.', ',')}%`),
            h(VProgressLinear, { props: { value: this.valor, color: cor, height: 4, rounded: true } }),
        ]);
    },
};

export default {
    components: {
        MerusDataTable, CadastroToolbar, BarraClasses, IndicadorPct, ExportTableCSV, ExportTablePdf,
        RoteirizacaoProgressoDestinos,
    },
    data() {
        const hoje = new Date();
        const ontem = new Date(hoje.getTime() - DIA_MS);
        const semanaAtras = new Date(hoje.getTime() - 7 * DIA_MS);
        return {
            user: null,
            recursos: [],
            formValidado: false,
            dti: isoDia(semanaAtras),
            dtf: isoDia(ontem),
            hoje: isoDia(hoje),
            menuDti: false,
            menuDtf: false,
            aba: 0,
            abaDia: 0,
            panorama: null,
            loadingPanorama: false,
            buscaLinhas: '',
            execucoes: [],
            loadingExecucoes: false,
            execucaoSelecionada: null,
            dias: [],
            loadingDias: false,
            diaSelecionado: null,
            viagens: [],
            removidas: [],
            loadingViagens: false,
            buscaViagens: '',
            filtroClasses: [],
            somenteProblemas: false,
            inconsistencias: [],
            loadingInconsistencias: false,
            filtroTiposInconsistencia: [],
            drawerTrilha: false,
            loadingTrilha: false,
            trilhaViagemId: null,
            trilha: { viagem: null, eventos: [], inconsistencias: [] },
            execucaoTrilha: null,
            detalhesAbertos: {},
            dialogReprocessamento: false,
            menuReprocDti: false,
            menuReprocDtf: false,
            reprocDti: null,
            reprocDtf: null,
            reprocessando: false,
            progresso: null,
            /** Painel flutuante: período pedido, status final de cada dia e a execução gerada. */
            painelProgresso: { visivel: false, recolhido: false, periodo: null, statusDias: null, idExecucao: null,
                falhou: false },
            exportando: false,
            reprocGuias: 'config',
            csvAtual: { content: [], headers: [], titulo: '', arquivo: '' },
            pollTimer: null,
            pollInFlight: false,
        };
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem('user'));
        this.carregaRecursos();
        this.pesquisa();
        const idViagem = Number(this.$route.query.id_viagem_grid);
        if (Number.isInteger(idViagem) && idViagem > 0) this.abrirTrilha(idViagem);
    },
    beforeDestroy() {
        this.limpaPoll();
    },
    computed: {
        guiasPorViagemPadrao() {
            return !!(this.panorama && this.panorama.opcoesPadrao && this.panorama.opcoesPadrao.guias_por_viagem);
        },
        podeReprocessar() {
            if (this.user && this.user.is_superadmin === 1) return true;
            return (this.recursos || []).some((r) => r && r.rota === ROTA_REPROCESSAMENTO);
        },
        cardsPanorama() {
            const t = (this.panorama && this.panorama.total) || {};
            const ok = (t.classes && t.classes.CONFORME) || 0;
            return [
                { chave: 'prev', icone: 'mdi-calendar-clock', cor: 'primary',
                    rotulo: this.$t('audit.tripAudit.overview.kpis.planned'), valor: this.numero(t.previstas),
                    dica: t.previstas_guia
                        ? this.$t('audit.tripAudit.overview.kpis.plannedFromRosterHint', { n: this.numero(t.previstas_guia) })
                        : '' },
                { chave: 'real', icone: 'mdi-bus-clock', cor: 'primary',
                    rotulo: this.$t('audit.tripAudit.overview.kpis.doneOnSlot'), valor: this.numero(t.realizadas_no_slot),
                    dica: this.$t('audit.tripAudit.overview.kpis.extrasHint', { n: this.numero(t.extras) }) },
                { chave: 'ok', icone: 'mdi-check-circle-outline', cor: 'success',
                    rotulo: this.$t('audit.tripAudit.overview.kpis.onTime'), valor: this.numero(ok) },
                { chave: 'nr', icone: 'mdi-calendar-remove-outline', cor: 'grey',
                    rotulo: this.$t('audit.tripAudit.overview.kpis.notDone'), valor: this.numero(t.nao_realizadas) },
                { chave: 'cump', icone: 'mdi-percent-outline', cor: this.corPct(t.cumprimento_pct),
                    rotulo: this.$t('audit.tripAudit.overview.kpis.compliance'), valor: this.pct(t.cumprimento_pct),
                    dica: this.$t('audit.tripAudit.overview.kpis.complianceHint') },
                { chave: 'pont', icone: 'mdi-timer-check-outline', cor: this.corPct(t.pontualidade_pct),
                    rotulo: this.$t('audit.tripAudit.overview.kpis.punctuality'), valor: this.pct(t.pontualidade_pct),
                    dica: this.$t('audit.tripAudit.overview.kpis.punctualityHint') },
            ];
        },
        headersPanoramaDias() {
            return [
                { text: this.$t('audit.tripAudit.headers.day'), value: 'dt_referencia' },
                { text: this.$t('audit.tripAudit.kpis.planned'), value: 'previstas', align: 'end' },
                { text: this.$t('audit.tripAudit.kpis.onGrid'), value: 'realizadas_no_slot', align: 'end' },
                { text: this.$t('audit.tripAudit.kpis.extras'), value: 'extras', align: 'end' },
                { text: this.$t('audit.tripAudit.kpis.notDone'), value: 'nao_realizadas', align: 'end' },
                { text: this.$t('audit.tripAudit.kpis.compliance'), value: 'cumprimento_pct' },
                { text: this.$t('audit.tripAudit.kpis.punctuality'), value: 'pontualidade_pct' },
                { text: this.$t('audit.tripAudit.overview.classes'), value: 'classes', sortable: false },
                { text: this.$t('audit.tripAudit.kpis.issues'), value: 'inconsistencias', align: 'end' },
                { text: this.$t('audit.tripAudit.overview.auditedAt'), value: 'execucao', sortable: false },
            ];
        },
        headersPanoramaLinhas() {
            return [
                { text: this.$t('audit.tripAudit.fields.line'), value: 'cod_linha' },
                { text: this.$t('audit.tripAudit.kpis.planned'), value: 'previstas', align: 'end' },
                { text: this.$t('audit.tripAudit.kpis.onGrid'), value: 'realizadas_no_slot', align: 'end' },
                { text: this.$t('audit.tripAudit.kpis.extras'), value: 'extras', align: 'end' },
                { text: this.$t('audit.tripAudit.kpis.notDone'), value: 'nao_realizadas', align: 'end' },
                { text: this.$t('audit.tripAudit.kpis.compliance'), value: 'cumprimento_pct' },
                { text: this.$t('audit.tripAudit.kpis.punctuality'), value: 'pontualidade_pct' },
                { text: this.$t('audit.tripAudit.overview.classes'), value: 'classes', sortable: false },
            ];
        },
        headersExecucoes() {
            return [
                { text: this.$t('audit.tripAudit.headers.id'), value: 'id_execucao' },
                { text: this.$t('audit.tripAudit.headers.origin'), value: 'origem' },
                { text: this.$t('audit.tripAudit.headers.user'), value: 'nome_usuario' },
                { text: this.$t('audit.tripAudit.headers.period'), value: 'periodo' },
                { text: this.$t('audit.tripAudit.headers.status'), value: 'status' },
                { text: this.$t('audit.tripAudit.headers.startedAt'), value: 'dt_inicio' },
                { text: this.$t('audit.tripAudit.headers.days'), value: 'dias', sortable: false },
                { text: this.$t('audit.tripAudit.fields.plannedSource'), value: 'previsto', sortable: false },
                { text: this.$t('audit.tripAudit.headers.version'), value: 'versao_algoritmo' },
            ];
        },
        headersDias() {
            return [
                { text: this.$t('audit.tripAudit.headers.day'), value: 'dt_referencia' },
                { text: this.$t('audit.tripAudit.headers.status'), value: 'status' },
                { text: this.$t('audit.tripAudit.kpis.planned'), value: 'previstas', align: 'end' },
                { text: this.$t('audit.tripAudit.kpis.onGrid'), value: 'realizadas_no_grid', align: 'end' },
                { text: this.$t('audit.tripAudit.kpis.extras'), value: 'extras', align: 'end' },
                { text: this.$t('audit.tripAudit.kpis.notDone'), value: 'nao_realizadas', align: 'end' },
                { text: this.$t('audit.tripAudit.kpis.compliance'), value: 'cumprimento_pct' },
                { text: this.$t('audit.tripAudit.kpis.punctuality'), value: 'pontualidade_pct' },
                { text: this.$t('audit.tripAudit.kpis.merges'), value: 'fusoes', align: 'end' },
                { text: this.$t('audit.tripAudit.kpis.issues'), value: 'n_inconsistencias', align: 'end' },
            ];
        },
        headersViagens() {
            return [
                { text: this.$t('audit.tripAudit.fields.classification'), value: 'classificacao_auditoria' },
                { text: this.$t('audit.tripAudit.fields.line'), value: 'cod_linha' },
                { text: this.$t('audit.tripAudit.fields.direction'), value: 'descricao_sentido' },
                { text: this.$t('audit.tripAudit.fields.vehicle'), value: 'numero_ordem_veiculo' },
                { text: this.$t('audit.tripAudit.fields.plannedVehicle'), value: 'numero_ordem_veiculo_previsto' },
                { text: this.$t('audit.tripAudit.fields.planned'), value: 'horario_saida_prevista' },
                { text: this.$t('audit.tripAudit.fields.departure'), value: 'horario_saida_realizada' },
                { text: this.$t('audit.tripAudit.fields.arrival'), value: 'horario_chegada_realizada' },
                { text: this.$t('audit.tripAudit.fields.opening'), value: 'abertura', sortable: false },
                { text: this.$t('audit.tripAudit.fields.closing'), value: 'fechamento', sortable: false },
                { text: this.$t('audit.tripAudit.fields.driver'), value: 'nome_motorista_realizado' },
                { text: this.$t('audit.tripAudit.kpis.issues'), value: 'n_inconsistencias' },
                { text: '', value: 'actions', sortable: false },
            ];
        },
        headersRemovidas() {
            return [
                { text: this.$t('audit.tripAudit.fields.decision'), value: 'decisao' },
                { text: this.$t('audit.tripAudit.fields.trip'), value: 'id_viagem_grid' },
                { text: this.$t('audit.tripAudit.fields.line'), value: 'cod_linha' },
                { text: this.$t('audit.tripAudit.fields.vehicle'), value: 'numero_ordem_veiculo' },
                { text: this.$t('audit.tripAudit.fields.details'), value: 'mensagem' },
                { text: '', value: 'actions', sortable: false },
            ];
        },
        headersInconsistencias() {
            return [
                { text: this.$t('audit.tripAudit.headers.day'), value: 'dia' },
                { text: this.$t('audit.tripAudit.fields.issueType'), value: 'titulo' },
                { text: this.$t('audit.tripAudit.fields.severity'), value: 'severidade' },
                { text: this.$t('audit.tripAudit.fields.vehicle'), value: 'numero_ordem_veiculo' },
                { text: this.$t('audit.tripAudit.fields.trip'), value: 'id_viagem_grid' },
                { text: this.$t('audit.tripAudit.fields.details'), value: 'descricao' },
                { text: '', value: 'actions', sortable: false },
            ];
        },
        opcoesClasses() {
            return CLASSES.map((c) => ({ text: this.$t(`audit.tripAudit.classes.${c}`), value: c }));
        },
        opcoesTiposInconsistencia() {
            return TIPOS_INCONSISTENCIA.map((t) => ({ text: this.tituloInconsistencia(t), value: t }));
        },
        viagensFiltradas() {
            return this.viagens.filter((v) => {
                if (this.filtroClasses.length && !this.filtroClasses.includes(v.classificacao_auditoria)) return false;
                if (!this.somenteProblemas) return true;
                return v.n_inconsistencias > 0
                    || ['INVALIDA', 'SUGERIDA', 'DIVERGENTE_MANUAL', 'DUPLICATA_MANUAL', 'INCOMPLETA']
                        .includes(v.classificacao_auditoria);
            });
        },
        removidasFormatadas() {
            return this.removidas.map((r) => ({
                ...r,
                decisao: this.$t(`audit.tripAudit.decisions.${r.codigo}`),
                mensagem: this.mensagemEvento(r),
            }));
        },
        inconsistenciasFormatadas() {
            return this.inconsistencias.map((i) => ({
                ...i,
                dia: this.formataData(i.dt_referencia),
                titulo: this.tituloInconsistencia(i.tipo),
                descricao: this.descricaoInconsistencia(i),
            }));
        },
        cardsDia() {
            const k = (this.diaSelecionado && this.diaSelecionado.contadores) || {};
            return [
                { chave: 'previstas', icone: 'mdi-calendar-clock', cor: 'primary',
                    rotulo: this.$t('audit.tripAudit.kpis.planned'), valor: this.numero(k.previstas) },
                { chave: 'grid', icone: 'mdi-bus-clock', cor: 'primary',
                    rotulo: this.$t('audit.tripAudit.kpis.onGrid'), valor: this.numero(k.realizadas_no_grid) },
                { chave: 'extras', icone: 'mdi-plus-circle-outline', cor: 'blue-grey',
                    rotulo: this.$t('audit.tripAudit.kpis.extras'), valor: this.numero(k.extras) },
                { chave: 'nr', icone: 'mdi-calendar-remove-outline', cor: 'grey',
                    rotulo: this.$t('audit.tripAudit.kpis.notDone'), valor: this.numero(k.nao_realizadas) },
                { chave: 'cump', icone: 'mdi-percent-outline', cor: this.corPct(k.cumprimento_pct),
                    rotulo: this.$t('audit.tripAudit.kpis.compliance'), valor: this.pct(k.cumprimento_pct) },
                { chave: 'pont', icone: 'mdi-timer-check-outline', cor: this.corPct(k.pontualidade_pct),
                    rotulo: this.$t('audit.tripAudit.kpis.punctuality'), valor: this.pct(k.pontualidade_pct) },
                { chave: 'fus', icone: 'mdi-call-merge', cor: 'indigo',
                    rotulo: this.$t('audit.tripAudit.kpis.merges'), valor: this.numero(k.fusoes) },
                { chave: 'ins', icone: 'mdi-plus-box-outline', cor: 'primary',
                    rotulo: this.$t('audit.tripAudit.kpis.created'), valor: this.numero(k.extras_inseridas) },
                { chave: 'rem', icone: 'mdi-delete-outline', cor: 'grey darken-1',
                    rotulo: this.$t('audit.tripAudit.kpis.removed'), valor: this.numero(k.extras_removidas) },
                { chave: 'sp', icone: 'mdi-map-marker-off-outline', cor: 'grey darken-1',
                    rotulo: this.$t('audit.tripAudit.kpis.noPosition'), valor: this.numero(k.sem_posicao) },
                { chave: 'esv', icone: 'mdi-account-alert-outline', cor: 'warning',
                    rotulo: this.$t('audit.tripAudit.kpis.boardingsWithoutTrip'), valor: this.numero(k.embarques_sem_viagem) },
                { chave: 'inc', icone: 'mdi-alert-outline', cor: 'warning',
                    rotulo: this.$t('audit.tripAudit.kpis.issues'), valor: this.numero(this.totalInconsistencias(this.diaSelecionado)) },
            ];
        },
        classesDia() {
            return ((this.diaSelecionado && this.diaSelecionado.contadores) || {}).classes || {};
        },
        execucoesTrilha() {
            const vistas = new Map();
            this.trilha.eventos.forEach((e) => {
                if (!vistas.has(e.id_execucao)) {
                    vistas.set(e.id_execucao, {
                        value: e.id_execucao,
                        text: `#${e.id_execucao} · ${this.$t(`audit.tripAudit.origins.${e.origem}`)} · ${this.formataDataHora(e.dt_execucao)}`,
                    });
                }
            });
            return [...vistas.values()];
        },
        eventosTrilha() {
            return this.trilha.eventos.filter((e) => e.id_execucao === this.execucaoTrilha
                && e.codigo !== 'FONTES_RESOLVIDAS');
        },
        diasReprocessamento() {
            const i = msDia(this.reprocDti);
            const f = msDia(this.reprocDtf);
            return Number.isFinite(i) && Number.isFinite(f) ? Math.round((f - i) / DIA_MS) + 1 : 0;
        },
        erroPeriodoReprocessamento() {
            if (!this.reprocDti || !this.reprocDtf || this.diasReprocessamento < 1) {
                return this.$t('audit.tripAudit.reprocess.invalidPeriod');
            }
            if (this.diasReprocessamento > MAX_DIAS_REPROCESSAMENTO) {
                return this.$t('audit.tripAudit.reprocess.periodTooLong', { dias: MAX_DIAS_REPROCESSAMENTO });
            }
            return null;
        },
        /** Dias do reprocessamento: do período pedido ou, ao acompanhar um job já em curso, do progresso. */
        diasProgresso() {
            const p = this.progresso;
            if (p && p.total && p.detalhe) {
                const primeiro = somaDias(p.detalhe, -p.done);
                return Array.from({ length: p.total }, (_, i) => somaDias(primeiro, i));
            }
            const per = this.painelProgresso.periodo;
            if (!per) return [];
            const n = Math.round((msDia(per.dtf) - msDia(per.dti)) / DIA_MS) + 1;
            return n > 0 ? Array.from({ length: n }, (_, i) => somaDias(per.dti, i)) : [];
        },
        itensProgresso() {
            const p = this.progresso;
            const finais = this.painelProgresso.statusDias;
            const dias = this.diasProgresso;
            if (!dias.length) {
                return [this.itemProgresso('aguardando', this.$t('audit.tripAudit.progress.title'), 'queued', 0,
                    this.$t('audit.tripAudit.progress.waiting'))];
            }
            return dias.map((dia, i) => {
                let status = 'queued';
                let pctDia = 0;
                if (finais) {
                    // Dia ausente da execução não chegou a ser processado (interrupção ou falha geral).
                    status = finais[dia] || 'queued';
                    pctDia = status === 'queued' ? 0 : 100;
                } else if (p && p.total) {
                    if (i < p.done) {
                        status = 'ready';
                        pctDia = 100;
                    } else if (i === p.done) {
                        status = this.painelProgresso.falhou ? 'error' : 'running';
                        pctDia = PCT_ETAPA[p.stage] || 0;
                    }
                }
                const mensagem = status === 'running' ? this.textoEtapa(p.stage)
                    : this.$t(`audit.tripAudit.progress.status.${status}`);
                return this.itemProgresso(dia, this.$t('audit.tripAudit.progress.day', { dia: this.formataData(dia) }),
                    status, pctDia, mensagem);
            });
        },
        progressoGeral() {
            const itens = this.itensProgresso;
            const total = this.diasProgresso.length;
            const prontos = itens.filter((i) => i.status === 'ready').length;
            if (!total) return { done: 0, total: 0, percent: 0, indeterminate: true };
            const soma = itens.reduce((a, i) => a + (i.status === 'queued' ? 0 : i.progress), 0);
            return { done: prontos, total, percent: Math.round(soma / total) };
        },
        tituloProgresso() {
            if (this.reprocessando) return this.$t('audit.tripAudit.progress.title');
            return this.painelProgresso.falhou || this.itensProgresso.some((i) => i.status === 'error')
                ? this.$t('audit.tripAudit.progress.titleFailed') : this.$t('audit.tripAudit.progress.titleDone');
        },
        resumoProgresso() {
            const g = this.progressoGeral;
            return g.total ? this.$t('audit.tripAudit.progress.summary', { done: g.done, total: g.total }) : '';
        },
        opcoesCsv() {
            const opcoes = [
                { chave: 'dias', texto: this.$t('audit.tripAudit.export.csvDays') },
                { chave: 'linhas', texto: this.$t('audit.tripAudit.export.csvLines') },
            ];
            if (this.diaSelecionado) {
                opcoes.push({ chave: 'viagens',
                    texto: this.$t('audit.tripAudit.export.csvTrips', { dia: this.formataData(this.diaSelecionado.dt_referencia) }) });
            }
            opcoes.push({ chave: 'inconsistencias', texto: this.$t('audit.tripAudit.export.csvIssues') });
            return opcoes;
        },
        /** Colunas exportadas (PDF/CSV): mesmo texto da tela, valores já formatados. */
        headersExportDias() {
            return [
                { text: this.$t('audit.tripAudit.headers.day'), value: 'dt_referencia', exportFormat: (v) => this.formataData(v) },
                ...this.colunasExportResumo(),
                { text: this.$t('audit.tripAudit.kpis.issues'), value: 'inconsistencias' },
                { text: this.$t('audit.tripAudit.overview.auditedAt'), value: 'execucao',
                    exportFormat: (v) => (v ? `${this.formataDataHora(v.dt_execucao)} (#${v.id_execucao})`
                        : this.$t('audit.tripAudit.overview.notAuditedDay')) },
            ];
        },
        headersExportLinhas() {
            return [
                { text: this.$t('audit.tripAudit.fields.line'), value: 'cod_linha' },
                { text: this.$t('audit.tripAudit.export.lineName'), value: 'nome_linha' },
                ...this.colunasExportResumo(),
            ];
        },
        headersExportViagens() {
            return [
                { text: this.$t('audit.tripAudit.export.tripNumber'), value: 'id_viagem_grid' },
                { text: this.$t('audit.tripAudit.fields.classification'), value: 'classificacao_auditoria',
                    exportFormat: (v, row) => (v ? this.$t(`audit.tripAudit.classes.${v}`)
                        : this.$t(`audit.tripAudit.notClassified.${this.motivoSemClassificacao(row)}`)) },
                { text: this.$t('audit.tripAudit.fields.line'), value: 'cod_linha' },
                { text: this.$t('audit.tripAudit.fields.direction'), value: 'descricao_sentido' },
                { text: this.$t('audit.tripAudit.fields.vehicle'), value: 'numero_ordem_veiculo' },
                { text: this.$t('audit.tripAudit.fields.planned'), value: 'horario_saida_prevista', exportFormat: (v) => this.formataHora(v) },
                { text: this.$t('audit.tripAudit.fields.plannedSource'), value: 'origem_previsto',
                    exportFormat: (v, row) => (!row.horario_saida_prevista ? ''
                        : this.$t(`audit.tripAudit.fields.plannedOrigins.${v === 'GUIA' ? 'guia' : 'quadro'}`)) },
                { text: this.$t('audit.tripAudit.fields.departure'), value: 'horario_saida_realizada', exportFormat: (v) => this.formataHora(v) },
                { text: this.$t('audit.tripAudit.fields.arrival'), value: 'horario_chegada_realizada', exportFormat: (v) => this.formataHora(v) },
                { text: this.$t('audit.tripAudit.fields.opening'), value: 'tipo_abertura_auditoria', exportFormat: (v) => this.motivo('opening', v) },
                { text: this.$t('audit.tripAudit.fields.closing'), value: 'tipo_fechamento_auditoria', exportFormat: (v) => this.motivo('closing', v) },
                { text: this.$t('audit.tripAudit.fields.driver'), value: 'nome_motorista_realizado' },
                { text: this.$t('audit.tripAudit.kpis.issues'), value: 'n_inconsistencias' },
            ];
        },
        headersExportInconsistencias() {
            return [
                { text: this.$t('audit.tripAudit.headers.day'), value: 'dia' },
                { text: this.$t('audit.tripAudit.fields.issueType'), value: 'titulo' },
                { text: this.$t('audit.tripAudit.fields.severity'), value: 'severidade',
                    exportFormat: (v) => this.$t(`audit.tripAudit.severities.${v}`) },
                { text: this.$t('audit.tripAudit.fields.vehicle'), value: 'numero_ordem_veiculo' },
                { text: this.$t('audit.tripAudit.export.tripNumber'), value: 'id_viagem_grid' },
                { text: this.$t('audit.tripAudit.fields.details'), value: 'descricao' },
            ];
        },
    },
    methods: {
        obrigatorio(v) {
            return !!v || this.$t('contract.messages.selectDate');
        },
        fimDepoisDoInicio() {
            return !this.dti || !this.dtf || this.dtf >= this.dti || this.$t('audit.tripAudit.reprocess.invalidPeriod');
        },
        alerta(mensagem, tipo) {
            EventBus.$emit('show-alert', { mensagem, tipo, duracao: 6000 });
        },
        carregaRecursos() {
            if (this.user && this.user.is_superadmin === 1) return;
            apiController.request(apiController.endpoints.getRecursosusuario, {
                params: { id: this.user && this.user.id_usuario },
                silent: true,
                onSuccess: (response) => { this.recursos = response.data; },
            });
        },
        pesquisa() {
            if (!this.dti || !this.dtf || this.dtf < this.dti) return;
            this.execucaoSelecionada = null;
            this.diaSelecionado = null;
            if (this.aba > 2) this.aba = 0;
            this.carregaPanorama();
            this.carregaExecucoes();
            if (this.aba === 2) this.carregaInconsistencias();
        },
        carregaPanorama() {
            this.loadingPanorama = true;
            apiController.request(apiController.endpoints.auditGetPanoramaauditoria, {
                data: { dti: this.dti, dtf: this.dtf },
                onSuccess: (response) => {
                    const d = response.data || {};
                    this.panorama = { total: d.total || {}, dias: d.dias || [], linhas: d.linhas || [],
                        inconsistencias: d.inconsistencias || [], opcoesPadrao: d.opcoes_padrao || {} };
                },
            }).catch(() => {}).finally(() => { this.loadingPanorama = false; });
        },
        carregaExecucoes() {
            this.loadingExecucoes = true;
            apiController.request(apiController.endpoints.auditGetExecucoesauditoria, {
                data: { dti: this.dti, dtf: this.dtf },
                onSuccess: (response) => { this.execucoes = response.data.execucoes || []; },
            }).catch(() => {}).finally(() => { this.loadingExecucoes = false; });
        },
        selecionaExecucao(item) {
            this.execucaoSelecionada = item;
            this.dias = [];
            this.loadingDias = true;
            return apiController.request(apiController.endpoints.auditGetDiasexecucaoauditoria, {
                data: { id_execucao: item.id_execucao },
                onSuccess: (response) => {
                    this.dias = (response.data.dias || []).map((d) => ({ ...d, ...(d.contadores || {}) }));
                },
            }).catch(() => {}).finally(() => { this.loadingDias = false; });
        },
        /** Linha do panorama: abre o dia na última execução que o auditou. */
        async abrirDiaPanorama(item) {
            if (!item.execucao) {
                this.alerta(this.$t('audit.tripAudit.overview.dayNotAudited'), 'info');
                return;
            }
            await this.selecionaExecucao({ id_execucao: item.execucao.id_execucao });
            const dia = this.dias.find((d) => d.dt_referencia === item.dt_referencia);
            if (dia) this.selecionaDia(dia);
        },
        selecionaDia(item) {
            this.diaSelecionado = item;
            this.filtroClasses = [];
            this.somenteProblemas = false;
            this.buscaViagens = '';
            this.abaDia = 0;
            this.viagens = [];
            this.removidas = [];
            this.loadingViagens = true;
            this.$nextTick(() => { this.aba = 3; });
            apiController.request(apiController.endpoints.auditGetViagensauditoria, {
                data: { dt_referencia: item.dt_referencia, id_execucao: item.id_execucao },
                onSuccess: (response) => {
                    this.viagens = response.data.viagens || [];
                    this.removidas = response.data.removidas || [];
                },
            }).catch(() => {}).finally(() => { this.loadingViagens = false; });
        },
        alternaClasse(classe) {
            const i = this.filtroClasses.indexOf(classe);
            if (i >= 0) this.filtroClasses.splice(i, 1);
            else this.filtroClasses.push(classe);
        },
        abrirInconsistenciasDoTipo(tipo) {
            this.filtroTiposInconsistencia = [tipo];
            this.aba = 2;
            this.carregaInconsistencias();
        },
        carregaInconsistencias() {
            if (!this.dti || !this.dtf || this.dtf < this.dti) return Promise.resolve();
            this.loadingInconsistencias = true;
            return apiController.request(apiController.endpoints.auditGetInconsistenciasauditoria, {
                data: { dti: this.dti, dtf: this.dtf, tipo: this.filtroTiposInconsistencia },
                onSuccess: (response) => { this.inconsistencias = response.data.inconsistencias || []; },
            }).catch(() => {}).finally(() => { this.loadingInconsistencias = false; });
        },
        abrirTrilha(idViagem) {
            this.trilhaViagemId = idViagem;
            this.drawerTrilha = true;
            this.loadingTrilha = true;
            this.detalhesAbertos = {};
            this.trilha = { viagem: null, eventos: [], inconsistencias: [] };
            apiController.request(apiController.endpoints.auditGetTrilhaviagem, {
                data: { id_viagem_grid: idViagem },
                onSuccess: (response) => {
                    const d = response.data || {};
                    this.trilha = { viagem: d.viagem, eventos: d.eventos || [], inconsistencias: d.inconsistencias || [] };
                    this.execucaoTrilha = this.trilha.eventos.length ? this.trilha.eventos[0].id_execucao : null;
                },
            }).catch(() => {}).finally(() => { this.loadingTrilha = false; });
        },
        alternaDetalhes(id) {
            this.$set(this.detalhesAbertos, id, !this.detalhesAbertos[id]);
        },
        temDetalhes(ev) {
            return this.linhasParametros(ev.params).length > 0 || this.comparacoes(ev).length > 0;
        },

        // --- Detalhes legíveis de um evento da trilha ----------------------------------------
        rotuloParametro(chave) {
            const k = `audit.tripAudit.paramLabels.${chave}`;
            return this.$te(k) ? this.$t(k) : chave;
        },
        /** Valor de um parâmetro já formatado (datas, minutos, motivos, classes e códigos traduzidos). */
        valorDetalhe(chave, valor) {
            if (valor == null || valor === '') return '-';
            if (typeof valor === 'boolean') return this.$t(`audit.tripAudit.details.${valor ? 'yes' : 'no'}`);
            if (PARAMETROS_MINUTOS.has(chave) && typeof valor === 'number') {
                return this.$t('audit.tripAudit.details.minutes', { n: String(valor).replace('.', ',') });
            }
            if (chave === 'motivo_abertura') return this.motivo('opening', valor);
            if (chave === 'motivo_fechamento') return this.motivo('closing', valor);
            if (chave === 'classe' && this.$te(`audit.tripAudit.classes.${valor}`)) {
                return this.$t(`audit.tripAudit.classes.${valor}`);
            }
            if (Array.isArray(valor)) return valor.map((v) => this.valorDetalhe(chave, v)).join(', ');
            if (typeof valor === 'object') {
                if (ehViagem(valor)) return this.descreveViagem(valor);
                return Object.entries(valor).filter(([, v]) => v != null)
                    .map(([k, v]) => `${this.rotuloParametro(k)}: ${this.valorDetalhe(k, v)}`).join(' · ');
            }
            return this.valorParametro(valor);
        },
        descreveViagem(v) {
            const partes = [v.cod_linha, `${this.formataDataHora(v.dt_inicio) || '?'} → ${this.formataHora(v.dt_fim) || '?'}`];
            if (v.fontes && v.fontes.length) partes.push(this.valorDetalhe('fontes', v.fontes));
            return partes.filter(Boolean).join(' · ');
        },
        /** Parâmetros do evento como linhas "rótulo: valor" ou tabelas (listas de objetos). */
        linhasParametros(params) {
            const linhas = [];
            Object.entries(params || {}).forEach(([chave, valor]) => {
                if (PARAMETROS_OCULTOS.has(chave) || valor == null || valor === ''
                    || (Array.isArray(valor) && !valor.length)
                    || (typeof valor === 'object' && !Array.isArray(valor) && !Object.keys(valor).length)) return;
                if (Array.isArray(valor) && valor.some((v) => v && typeof v === 'object')) {
                    linhas.push({ rotulo: this.rotuloParametro(chave), tabela: this.tabelaDetalhe(valor) });
                } else {
                    linhas.push({ rotulo: this.rotuloParametro(chave), valor: this.valorDetalhe(chave, valor) });
                }
            });
            return linhas;
        },
        tabelaDetalhe(itens) {
            const chaves = [];
            itens.forEach((item) => Object.keys(item || {}).forEach((k) => {
                if (!PARAMETROS_OCULTOS.has(k) && !chaves.includes(k) && itens.some((i) => i && i[k] != null)) chaves.push(k);
            }));
            return {
                colunas: chaves.map((k) => ({ chave: k, rotulo: this.rotuloParametro(k) })),
                linhas: itens.map((item) => Object.fromEntries(chaves.map((k) => [k, this.valorDetalhe(k, (item || {})[k])]))),
            };
        },
        /** Antes/depois da viagem (ou das duas viagens de uma sobreposição) campo a campo. */
        comparacoes(ev) {
            const { antes, depois } = ev;
            if (!antes && !depois) return [];
            const pares = (antes && antes.a) || (depois && depois.a)
                ? ['a', 'b'].map((k) => [this.rotuloParametro(k), antes && antes[k], depois && depois[k]])
                : [[null, antes, depois]];
            return pares.filter(([, a, d]) => ehViagem(a) || ehViagem(d)).map(([titulo, a, d]) => ({
                titulo,
                temAntes: !!a,
                temDepois: !!d,
                linhas: CAMPOS_VIAGEM.filter((c) => (a && a[c] != null) || (d && d[c] != null)).map((c) => {
                    const va = a ? this.valorDetalhe(c, a[c]) : '';
                    const vd = d ? this.valorDetalhe(c, d[c]) : '';
                    return { chave: c, rotulo: this.rotuloParametro(c), antes: va, depois: vd, mudou: !!a && !!d && va !== vd };
                }),
            }));
        },
        /** Valor de parâmetro legível nas frases dos eventos: datas no formato local e códigos traduzidos. */
        valorParametro(valor) {
            if (valor == null) return '-';
            if (Array.isArray(valor)) {
                return valor.filter((v) => typeof v !== 'object').map((v) => this.valorParametro(v)).join(', ');
            }
            if (typeof valor === 'object') return '';
            if (typeof valor === 'string') {
                if (DATA_HORA_RE.test(valor)) return this.formataDataHora(valor);
                if (this.$te(`audit.tripAudit.values.${valor}`)) return this.$t(`audit.tripAudit.values.${valor}`);
            }
            return String(valor);
        },
        mensagemEvento(ev) {
            const chave = `audit.tripAudit.events.${ev.codigo}`;
            if (!this.$te(chave)) return ev.codigo;
            const params = {};
            Object.entries(ev.params || {}).forEach(([k, v]) => { params[k] = this.valorParametro(v); });
            return this.$t(chave, params);
        },
        tituloInconsistencia(tipo) {
            const chave = `audit.tripAudit.issues.${tipo}.title`;
            return this.$te(chave) ? this.$t(chave) : tipo;
        },
        descricaoInconsistencia(inc) {
            const chave = `audit.tripAudit.issues.${inc.tipo}.description`;
            if (!this.$te(chave)) return '';
            const params = {};
            Object.entries(inc.detalhes || {}).forEach(([k, v]) => { params[k] = this.valorParametro(v); });
            return this.$t(chave, params);
        },
        /** Chave do motivo de uma viagem estar sem classificação da auditoria. */
        motivoSemClassificacao(item) {
            if (!Number(item.linha_cadastrada)) return 'lineMissing';
            if (!Number(item.linha_auditada)) return 'lineNotAudited';
            return 'notAudited';
        },
        motivo(tipo, id) {
            if (id == null) return '';
            const chave = `audit.tripAudit.reasons.${tipo}.${id}`;
            return this.$te(chave) ? this.$t(chave) : String(id);
        },
        legendaClasses(classes) {
            const c = classes || {};
            const total = CLASSES.reduce((a, k) => a + (c[k] || 0), 0);
            return CLASSES.filter((k) => c[k]).map((k) => ({
                classe: k, total: c[k], pct: total ? Math.round((1000 * c[k]) / total) / 10 : null,
            }));
        },
        kpi(item, campo) {
            return item && item.contadores ? item.contadores[campo] : null;
        },
        totalInconsistencias(item) {
            const inc = (item && item.contadores && item.contadores.inconsistencias) || {};
            return Object.values(inc).reduce((a, b) => a + b, 0);
        },
        numero(v) {
            return v == null ? '-' : Number(v).toLocaleString(this.$i18n.locale);
        },
        pct(v) {
            return v == null ? '-' : `${String(v).replace('.', ',')}%`;
        },
        corPct(v) {
            if (v == null) return 'grey';
            return v >= 90 ? 'success' : v >= 70 ? 'warning' : 'error';
        },
        corStatus(status) {
            return { CONCLUIDA: 'success', EXECUTANDO: 'info', CONCLUIDA_COM_FALHAS: 'warning', FALHA: 'error',
                INTERROMPIDA: 'grey' }[status] || 'grey';
        },
        corClasse(classe) {
            return CORES_CLASSE[classe] || 'grey';
        },
        corSeveridade(sev) {
            return { ERRO: 'error', AVISO: 'warning' }[sev] || 'primary';
        },
        iconeEtapa(etapa) {
            return ICONES_ETAPA[etapa] || 'mdi-circle-small';
        },
        classeExecucao(item) {
            return this.execucaoSelecionada && item.id_execucao === this.execucaoSelecionada.id_execucao ? 'linha-selecionada' : '';
        },
        formataData(valor) {
            const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(valor || ''));
            return m ? `${m[3]}/${m[2]}/${m[1]}` : '';
        },
        formataDataHora(valor) {
            const m = DATA_HORA_RE.exec(String(valor || ''));
            return m ? `${m[3]}/${m[2]}/${m[1]} ${m[4]}:${m[5]}` : '';
        },
        formataHora(valor) {
            const m = DATA_HORA_RE.exec(String(valor || ''));
            return m ? `${m[4]}:${m[5]}` : '';
        },

        // --- Painel de progresso do reprocessamento ------------------------------------------
        itemProgresso(chave, rotulo, status, progresso, mensagem) {
            const visual = VISUAL_STATUS[status];
            return {
                key: chave, label: rotulo, status, statusIcon: visual.icon, statusColor: visual.color,
                progress: progresso, message: mensagem, active: false, retryable: false,
            };
        },
        textoEtapa(etapa) {
            const texto = this.$te(`audit.tripAudit.reprocess.steps.${etapa}`)
                ? this.$t(`audit.tripAudit.reprocess.steps.${etapa}`) : String(etapa || '');
            return texto.charAt(0).toUpperCase() + texto.slice(1);
        },
        /** Clique num dia do painel: depois de concluído, abre o dia na execução gerada. */
        async abrirDiaReprocessado(dia) {
            const idExecucao = this.painelProgresso.idExecucao;
            if (!idExecucao || this.reprocessando) return;
            await this.selecionaExecucao({ id_execucao: idExecucao });
            const item = this.dias.find((d) => d.dt_referencia === dia);
            if (item) this.selecionaDia(item);
        },
        /** Status final de cada dia, lido da execução que o worker criou. */
        carregaStatusDias(idExecucao) {
            this.painelProgresso.idExecucao = idExecucao;
            return apiController.request(apiController.endpoints.auditGetDiasexecucaoauditoria, {
                data: { id_execucao: idExecucao },
                silent: true,
                onSuccess: (response) => {
                    const status = {};
                    (response.data.dias || []).forEach((d) => {
                        status[d.dt_referencia] = d.status === 'CONCLUIDA' ? 'ready' : 'error';
                    });
                    this.painelProgresso.statusDias = status;
                },
            }).catch(() => {});
        },

        // --- Exportação ----------------------------------------------------------------------
        colunasExportResumo() {
            const classe = (c) => (_, row) => (row.classes && row.classes[c]) || 0;
            return [
                { text: this.$t('audit.tripAudit.kpis.planned'), value: 'previstas' },
                { text: this.$t('audit.tripAudit.kpis.onGrid'), value: 'realizadas_no_slot' },
                { text: this.$t('audit.tripAudit.kpis.extras'), value: 'extras' },
                { text: this.$t('audit.tripAudit.kpis.notDone'), value: 'nao_realizadas' },
                { text: this.$t('audit.tripAudit.kpis.compliance'), value: 'cumprimento_pct', exportFormat: (v) => this.pct(v) },
                { text: this.$t('audit.tripAudit.kpis.punctuality'), value: 'pontualidade_pct', exportFormat: (v) => this.pct(v) },
                ...CLASSES.map((c) => ({ text: this.$t(`audit.tripAudit.classes.${c}`), value: `classe_${c}`, exportFormat: classe(c) })),
                { text: this.$t('audit.tripAudit.export.notAuditedTrips'), value: 'nao_auditadas' },
            ];
        },
        nomeArquivo(parte) {
            return `auditoria_viagens_${parte}_${this.dti}_${this.dtf}`;
        },
        /** Seções do relatório PDF, montadas na hora da exportação. */
        secoesPdf() {
            const t = this.panorama.total;
            const indicadores = [
                ...this.cardsPanorama.map((c) => ({ rotulo: c.rotulo, valor: c.valor })),
                { rotulo: this.$t('audit.tripAudit.kpis.extras'), valor: this.numero(t.extras) },
                { rotulo: this.$t('audit.tripAudit.export.notAuditedTrips'), valor: this.numero(t.nao_auditadas) },
                { rotulo: this.$t('audit.tripAudit.kpis.issues'), valor: this.numero(t.inconsistencias) },
                { rotulo: this.$t('audit.tripAudit.export.auditedDays'), valor: `${t.dias_auditados}/${t.dias}` },
            ];
            const dias = this.panorama.dias;
            const pcts = dias.flatMap((d) => [d.cumprimento_pct, d.pontualidade_pct]).filter((v) => v != null);
            const secoes = [
                { sectionTitle: this.$t('audit.tripAudit.export.indicators'), content: indicadores, headers: [
                    { text: this.$t('audit.tripAudit.export.indicator'), value: 'rotulo' },
                    { text: this.$t('audit.tripAudit.export.value'), value: 'valor' },
                ] },
                { sectionTitle: this.$t('audit.tripAudit.overview.distribution'),
                    content: this.legendaClasses(t.classes), headers: [
                        { text: this.$t('audit.tripAudit.fields.classification'), value: 'classe',
                            exportFormat: (v) => this.$t(`audit.tripAudit.classes.${v}`) },
                        { text: this.$t('audit.tripAudit.export.trips'), value: 'total', exportFormat: (v) => this.numero(v) },
                        { text: '%', value: 'pct', exportFormat: (v) => this.pct(v) },
                    ] },
            ];
            if (dias.length && pcts.length) {
                secoes.push({ sectionTitle: this.$t('audit.tripAudit.export.chart'), chart: {
                    kind: 'bars',
                    labels: dias.map((d) => this.formataData(d.dt_referencia).slice(0, 5)),
                    series: [
                        { label: this.$t('audit.tripAudit.kpis.compliance'), color: COR_CUMPRIMENTO,
                            values: dias.map((d) => d.cumprimento_pct || 0) },
                        { label: this.$t('audit.tripAudit.kpis.punctuality'), color: COR_PONTUALIDADE,
                            values: dias.map((d) => d.pontualidade_pct || 0) },
                    ],
                    legend: [
                        { label: this.$t('audit.tripAudit.kpis.compliance'), color: COR_CUMPRIMENTO },
                        { label: this.$t('audit.tripAudit.kpis.punctuality'), color: COR_PONTUALIDADE },
                    ],
                    maxLabel: this.pct(Math.max(...pcts)),
                } });
            }
            secoes.push(
                { sectionTitle: this.$t('audit.tripAudit.overview.byDay'), headers: this.headersExportDias, content: dias },
                { sectionTitle: this.$t('audit.tripAudit.overview.byLine'), headers: this.headersExportLinhas,
                    content: this.panorama.linhas },
                { sectionTitle: this.$t('audit.tripAudit.overview.issuesByType'), content: this.panorama.inconsistencias,
                    headers: [
                        { text: this.$t('audit.tripAudit.fields.issueType'), value: 'tipo', exportFormat: (v) => this.tituloInconsistencia(v) },
                        { text: this.$t('audit.tripAudit.fields.severity'), value: 'severidade',
                            exportFormat: (v) => this.$t(`audit.tripAudit.severities.${v}`) },
                        { text: this.$t('audit.tripAudit.export.total'), value: 'total' },
                    ] },
            );
            if (this.diaSelecionado) {
                secoes.push({
                    sectionTitle: this.$t('audit.tripAudit.export.tripsOfDay', { dia: this.formataData(this.diaSelecionado.dt_referencia) }),
                    headers: this.headersExportViagens, content: this.viagensFiltradas,
                });
            }
            return secoes;
        },
        exportaPdf() {
            if (!this.panorama) return;
            const t = this.panorama.total;
            const subtitulo = this.$t('audit.tripAudit.export.subtitle', {
                dti: this.formataData(this.dti), dtf: this.formataData(this.dtf), auditados: t.dias_auditados, dias: t.dias,
            });
            this.$refs.exportPdf.onBuildClick(this.$t('audit.tripAudit.title'), subtitulo, [], [], this.nomeArquivo('relatorio'));
        },
        async exportaCsv(tipo) {
            const opcao = this.opcoesCsv.find((o) => o.chave === tipo);
            let content;
            let headers;
            if (tipo === 'dias') {
                content = this.panorama.dias;
                headers = this.headersExportDias;
            } else if (tipo === 'linhas') {
                content = this.panorama.linhas;
                headers = this.headersExportLinhas;
            } else if (tipo === 'viagens') {
                content = this.viagensFiltradas;
                headers = this.headersExportViagens;
            } else {
                if (!this.inconsistencias.length) await this.carregaInconsistencias();
                content = this.inconsistenciasFormatadas;
                headers = this.headersExportInconsistencias;
            }
            const parte = tipo === 'viagens' ? `viagens_${this.diaSelecionado.dt_referencia}` : tipo;
            this.csvAtual = { content, headers, titulo: opcao ? opcao.texto : tipo, arquivo: this.nomeArquivo(parte) };
            await this.$nextTick();
            this.$refs.exportCsv.openExportCsvDialog();
        },

        // --- Reprocessamento (mesmo fluxo do RELEmbarques.vue) ---------------------------------
        abrirReprocessamento() {
            if (this.reprocessando) return;
            this.reprocDti = this.dti;
            this.reprocDtf = this.dtf;
            this.reprocGuias = 'config';
            this.dialogReprocessamento = true;
        },
        async confirmarReprocessamento() {
            if (this.erroPeriodoReprocessamento || this.reprocessando) return;
            this.dialogReprocessamento = false;
            this.reprocessando = true;
            this.progresso = null;
            this.abrePainel({ dti: this.reprocDti, dtf: this.reprocDtf });
            let idProcesso = null;
            try {
                const res = await apiController.request(apiController.endpoints.auditReprocessaauditoriaviagens, {
                    data: {
                        dti: this.reprocDti,
                        dtf: this.reprocDtf,
                        // null = usa configuracoes.auditoria_guias_por_viagem
                        guias_por_viagem: { config: null, on: true, off: false }[this.reprocGuias],
                    },
                    silent: true,
                });
                idProcesso = res.data && res.data.id_processo;
            } catch (e) {
                const data = (e.response && e.response.data) || {};
                if (e.response && e.response.status === 409 && data.id_processo) {
                    this.alerta(data.mensagem || this.$t('audit.tripAudit.reprocess.running'), 'info');
                    // Outro reprocessamento: os dias vêm do progresso dele, não do período pedido.
                    this.abrePainel(null);
                    this.poll(data.id_processo);
                    return;
                }
                this.falha(data.mensagem);
                return;
            }
            if (!idProcesso) {
                this.falha();
                return;
            }
            this.alerta(this.$t('audit.tripAudit.reprocess.queued'), 'info');
            this.poll(idProcesso);
        },
        abrePainel(periodo) {
            this.painelProgresso = { visivel: true, recolhido: false, periodo, statusDias: null, idExecucao: null,
                falhou: false };
        },
        limpaPoll() {
            if (this.pollTimer != null) clearInterval(this.pollTimer);
            this.pollTimer = null;
            this.pollInFlight = false;
        },
        falha(mensagem) {
            this.limpaPoll();
            this.reprocessando = false;
            this.painelProgresso.falhou = true;
            this.alerta(mensagem || this.$t('audit.tripAudit.reprocess.error'), 'error');
        },
        mensagemFalhaScheduler(processo) {
            const chave = processo && processo.mensagem_scheduler;
            if (chave === 'MSG_BLOQUEIO_ALLOWLIST') return this.$t('audit.tripAudit.reprocess.blocked');
            if (chave === 'MSG_INTERRUPCAO_SIGTERM' || chave === 'MSG_INTERRUPCAO_SIGTERM_FALHOU') {
                return this.$t('audit.tripAudit.reprocess.interrupted');
            }
            return this.$t('audit.tripAudit.reprocess.error');
        },
        conclui(resultado) {
            this.limpaPoll();
            // Inclusive com falha: a execução diz quais dias concluíram e quais falharam.
            if (resultado && resultado.id_execucao) {
                this.carregaStatusDias(resultado.id_execucao);
            } else if (resultado && !resultado.erro) {
                this.painelProgresso.statusDias = Object.fromEntries(this.diasProgresso.map((d) => [d, 'ready']));
            }
            this.reprocessando = false;
            if (!resultado || resultado.erro) {
                this.falha(resultado && resultado.codigo === 'AUDITORIA_EM_ANDAMENTO'
                    ? this.$t('audit.tripAudit.reprocess.locked') : null);
                return;
            }
            this.alerta(this.$t('audit.tripAudit.reprocess.done', {
                ok: resultado.dias_ok || 0, total: resultado.dias || 0,
            }), resultado.dias_falha ? 'warning' : 'success');
            this.pesquisa();
        },
        poll(idProcesso) {
            this.limpaPoll();
            this.reprocessando = true;
            const deadline = Date.now() + TIMEOUT_MS;
            const pendingDeadline = Date.now() + PENDING_TIMEOUT_MS;
            const pollOnce = () => {
                if (Date.now() > deadline) return this.falha(this.$t('audit.tripAudit.reprocess.timeout'));
                if (this.pollInFlight) return;
                this.pollInFlight = true;
                apiController.request(apiController.endpoints.schedulerGetProcessoschedulerbyid, {
                    data: { id_processo: idProcesso },
                    config: { timeout: 30000 },
                    silent: true,
                    onSuccess: (statusRes) => {
                        this.pollInFlight = false;
                        const pollData = statusRes.data || {};
                        if (pollData.erro) return this.falha(pollData.mensagem);
                        const processo = pollData.processo || {};
                        if (processo.status === 'PENDING') {
                            if (Date.now() > pendingDeadline) this.falha(this.$t('audit.tripAudit.reprocess.notStarted'));
                            return;
                        }
                        if (processo.status === 'EXECUTING') {
                            if (pollData.progresso) this.progresso = pollData.progresso;
                            return;
                        }
                        if (processo.status !== 'DONE') return this.falha(this.mensagemFalhaScheduler(processo));
                        this.conclui(pollData.resultado);
                    },
                    onError: (e) => {
                        const data = e.response && e.response.data;
                        this.falha((data && (data.message || data.mensagem)) || e.message);
                    },
                });
            };
            this.pollTimer = setInterval(pollOnce, POLL_MS);
            pollOnce();
        },
    },
};
</script>

<style scoped>
.auditoria-viagens {
    max-width: 100%;
    padding-top: 24px;
}
.kpi-card {
    padding: 12px 14px;
}
.barra-classes {
    display: flex;
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
}
.barra-mini {
    min-width: 120px;
}
.indicador-pct {
    min-width: 72px;
}
.trilha-detalhes {
    margin-top: 6px;
    padding: 8px 10px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.03);
    font-size: 12px;
}
.detalhe-linha {
    display: flex;
    gap: 8px;
    padding: 2px 0;
}
.detalhe-rotulo {
    min-width: 160px;
    color: rgba(0, 0, 0, 0.6);
}
.tabela-detalhe {
    background: transparent !important;
}
.tabela-detalhe ::v-deep th,
.tabela-detalhe ::v-deep td {
    font-size: 12px !important;
    height: 26px !important;
}
.linha-alterada td {
    font-weight: 500;
}
.tabela-clicavel ::v-deep tbody tr {
    cursor: pointer;
}
::v-deep .linha-selecionada {
    background-color: rgba(25, 118, 210, 0.08);
}
</style>
